


















































import { Component, Ref, Vue } from 'vue-property-decorator';
import PermissionService from '@/utils/permission-service';
import HolderNewButton from '@/components/ProductVariantHolder/HolderNewButton.vue';
import HolderEditButton from '@/components/ProductVariantHolder/HolderEditButton.vue';
import HolderDeleteButton from '@/components/ProductVariantHolder/HolderDeleteButton.vue';
import SApolloTable from '@/components/UI/Table/SApolloTable.vue';
import { GQL_currentUnitProductVariantHolders_currentUnit_productVariantHolders } from '@/queries/__generated__/currentUnitProductVariantHolders';
import gql from 'graphql-tag';
import { productVariantHolderFragments } from '@/queries/ProductVariantHolderFragments';

const ALL_PRODUCT_VARIANT_HOLDERS = gql`
  query currentUnitProductVariantHolders {
    currentUnit {
      id
      productVariantHolders {
        ...productVariantHolderFragments
      }
    }
  },
  ${productVariantHolderFragments}
`;

@Component({
  components: {
      HolderNewButton,
      HolderEditButton,
      HolderDeleteButton,
  },
})
export default class ProductVariantHolderList extends Vue {
  @Ref() private table?: SApolloTable<GQL_currentUnitProductVariantHolders_currentUnit_productVariantHolders[]>;

  private ALL_PRODUCT_VARIANT_HOLDERS = ALL_PRODUCT_VARIANT_HOLDERS
  private PermissionService = PermissionService;


  private displayProducts(holder: GQL_currentUnitProductVariantHolders_currentUnit_productVariantHolders) {
    const variants = holder.variants;

    if (variants.length > 3) {
      return variants.slice(0, 3).map(variant => variant.name).join(', ') + '...';
    } else {
      return variants.map(variant => variant.name).join(', ');
    }
  }

  private resetTableResult() {
    this.table?.refetch();
  }
}
